
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VideoTextureEffect extends BaseParallaxEffect implements ParallaxEffect {
    private static videoCache: Map<string, HTMLVideoElement> = new Map();

    public render(pc: ParallaxContext): void {
        const { ctx, config, width, height, time } = pc;
        const url = config.parallaxVideoUrl;
        if (!url) return;

        let video = VideoTextureEffect.videoCache.get(url);
        if (!video) {
            video = document.createElement('video');
            video.src = url;
            video.loop = true;
            video.muted = true;
            video.play().catch(e => console.warn("Video play failed", e));
            VideoTextureEffect.videoCache.set(url, video);
        }

        if (video.readyState >= 2) {
            ctx.save();
            ctx.globalAlpha *= (config.parallaxMediaOpacity || 1.0);
            
            const scale = config.parallaxScale || 1.0;
            const vw = video.videoWidth * scale;
            const vh = video.videoHeight * scale;
            
            const autoX = (config.parallaxAutoScrollX || 0) * time * 100;
            const autoY = (config.parallaxAutoScrollY || 0) * time * 100;
            
            const startX = -width - (autoX % vw);
            const startY = -height - (autoY % vh);

            for (let x = startX; x < width + 1000; x += vw) {
                for (let y = startY; y < height + 1000; y += vh) {
                    ctx.drawImage(video, x, y, vw, vh);
                }
            }
            ctx.restore();
        }
    }
}
